<template>
  <div class="AdvertisementsMetrics">
    <Card :title="$t('advertisements.total')">
      <CounterDisplay :value="metrics.totalAdvertisements" icon="target" />
    </Card>
    <Card :title="$t('advertisements.total-investment')">
      <CounterDisplay :value="metrics.totalInversion" icon="payment" />
    </Card>
    <Card :title="$t('advertisements.average')">
      <CounterDisplay :value="metrics.advertisementAverage" icon="target" />
    </Card>
  </div>
</template>

<script>
import { Card, CounterDisplay } from '@/components';
import { getAdvertisementsMetrics } from '@/api';

export default {
  name: 'AdvertisementsMetrics',
  data() {
    return {
      metrics: {},
    };
  },
  components: {
    Card,
    CounterDisplay,
  },
  created() {
    getAdvertisementsMetrics().then(
      data => {
        this.metrics = data;
      },
      err => {
        console.log('Fetch Error: ', err);
      }
    );
  },
};
</script>

<style lang="scss">
.AdvertisementsMetrics {
  display: flex;
  justify-content: center;
  .Card {
    margin-right: rem(10);
    margin-left: rem(10);
    width: rem(250);
    max-width: rem(300);
  }
}
</style>
